/**
 * Created by DynamicDog on 2016-12-13.
 * Collection module for often-used modules and pipes.
 */
import { NgModule }            from '@angular/core';
import { CommonModule }        from '@angular/common';
import { FormsModule }         from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { TranslatePipe } from './pipes/translate.pipe';

@NgModule({
    imports:      [ CommonModule,MaterialModule ],
    declarations: [ TranslatePipe ],
    exports:      [ TranslatePipe,
        CommonModule, FormsModule,MaterialModule ]
})
export class SharedModule { }


// WEBPACK FOOTER //
// ./app/shared.module.ts